import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { MedicalDeviceAwardCriteria } from '@dreryk/egabinet-ezwm-frontend-api';

import {
   createDynamicColumnsWidth,
   SelectableTable,
   SelectableTableColumnConfiguration,
} from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../../translations';
import {
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormSetValue,
   MedicalDeviceOrderFormWatch,
} from '../../medicalDeviceOrder.types';

type DeviceAwardCriteriaFieldProps = {
   readonly watch: MedicalDeviceOrderFormWatch;
   readonly register: MedicalDeviceOrderFormRegister;
   readonly setValue: MedicalDeviceOrderFormSetValue;
};

const StyledSelectableTable = styled<typeof SelectableTable>(SelectableTable)`
   width: 750px;
` as typeof SelectableTable;

export const DeviceAwardCriteriaField = (props: DeviceAwardCriteriaFieldProps): JSX.Element => {
   const [previousDeviceId, setPreviousDeviceId] = useState<number | null>(null);
   const device = props.watch('device') ?? null;
   const columns = useMemo<SelectableTableColumnConfiguration<MedicalDeviceAwardCriteria>[]>(() => {
      const columnWidths = createDynamicColumnsWidth({
         code: '60px',
         name: '100%',
      });
      return [
         {
            name: 'code',
            accessor: 'code',
            label: medicalDevicesTranslationKeys.fields.code,
            width: columnWidths.code,
            sortingDisabled: true,
         },
         {
            name: 'name',
            accessor: 'name',
            label: medicalDevicesTranslationKeys.fields.criteriaName,
            width: columnWidths.name,
            sortingDisabled: true,
         },
      ];
   }, []);
   const dataConfiguration = useMemo(
      () => ({
         data: device?.awardCriteria ?? [],
      }),
      [device]
   );
   // TODO DREGAB-5927 - do sprawdzenia po migracji do RHF v7, czy działa ustawianie defaultValue po ponownym zamontowaniu pola
   useEffect(() => {
      if (device && device.id !== previousDeviceId) {
         setPreviousDeviceId(device.id);
         if (device.awardCriteria?.length === 1) {
            props.setValue('deviceAwardCriteria', [device.awardCriteria.at(0)]);
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [device]);

   return (
      <StyledSelectableTable<MedicalDeviceAwardCriteria>
         testId={'deviceAwardCriteria'}
         columns={columns}
         label={medicalDevicesTranslationKeys.fields.deviceAwardCriteria}
         controller={props.register('deviceAwardCriteria', {
            required: {
               value: true,
               message: medicalDevicesTranslationKeys.fields.chooseAtLeastOneCriteria,
            },
         })}
         dataConfiguration={dataConfiguration}
         keyExtractor={'code'}
      />
   );
};
